import {DesignScreen} from '../../../stores/DesignScreen';
import {ColumnsDesignCollection} from './ColumnsDesignCollection';

export class ColumnsDesignScreen extends DesignScreen {
    constructor(screen, name) {
        super(screen, name);
        this.collection = new ColumnsDesignCollection(null);
    }

    setCollection(data) {
        this.collection.insertFields(this, data.fields);
    }

    checkReloadNeededOnRestore(screensStore) {
        screensStore.isReloadNeeded = true;
    }
}
